// Amplitude Analytics initialization and helpers.
// SDK docs: https://amplitude.com/docs/sdks/analytics/browser/browser-sdk-2
import * as amplitude from '@amplitude/analytics-browser';

// Public Amplitude project API key — safe to expose in client code.
// You can also override it at build time with VITE_AMPLITUDE_API_KEY.
const AMPLITUDE_API_KEY =
  (import.meta.env.VITE_AMPLITUDE_API_KEY as string | undefined) ||
  'REPLACE_WITH_AMPLITUDE_API_KEY';

let initialized = false;

export const initAmplitude = () => {
  if (initialized) return;
  if (!AMPLITUDE_API_KEY || AMPLITUDE_API_KEY === 'REPLACE_WITH_AMPLITUDE_API_KEY') {
    console.warn('[amplitude] API key missing — analytics disabled.');
    return;
  }

  amplitude.init(AMPLITUDE_API_KEY, {
    autocapture: {
      attribution: true,
      pageViews: false, // we send page_viewed manually on route changes
      sessions: true,
      formInteractions: true,
      fileDownloads: true,
      elementInteractions: false,
    },
  });

  initialized = true;
};

export const trackPageViewed = (path: string, extra?: Record<string, unknown>) => {
  if (!initialized) return;
  amplitude.track('page_viewed', {
    path,
    url: typeof window !== 'undefined' ? window.location.href : path,
    referrer: typeof document !== 'undefined' ? document.referrer : '',
    ...extra,
  });
};

export const trackButtonClick = (
  buttonName: string,
  extra?: Record<string, unknown>,
) => {
  if (!initialized) return;
  amplitude.track('button_clicked', {
    button_name: buttonName,
    path: typeof window !== 'undefined' ? window.location.pathname : undefined,
    ...extra,
  });
};

export const identifyUser = (userId: string, traits?: Record<string, unknown>) => {
  if (!initialized) return;
  amplitude.setUserId(userId);
  if (traits) {
    const identify = new amplitude.Identify();
    for (const [k, v] of Object.entries(traits)) {
      identify.set(k, v as string | number | boolean);
    }
    amplitude.identify(identify);
  }
};

export const resetAmplitudeUser = () => {
  if (!initialized) return;
  amplitude.reset();
};
